import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Cart, Drug, MedicalTest } from '../models';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class CartService {
  headers: HttpHeaders = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
  cartProductsSubject = new BehaviorSubject<MedicalTest[] | Drug[]>([]);

  constructor(private http: HttpClient) {}

  /**
   * Gets the user' cart details
   * @return server response
   */
  getUserCart(userId: number) {
    return this.http.get(
        `user-cart/${userId}`)
        .pipe(map(response => response as Cart | any));
  }

  /**
   * Adds item to cart
   * @param formData
   */
  createCart(formData: FormData) { 
    return this.http.post(
      'cart', formData)
      .pipe(map(response => response));
  }

  /**
   * Updates cart item
   * @param userId
   * @param formData
   */
  updateCart(userId: number, formData: FormData) {
    return this.http.post(`cart/${userId}`, formData);
  }

  /**
   * Saves the cart items
   * @param products selected
   */
  saveToCart(products: (MedicalTest | Drug)[]) {
    const currentCart: (MedicalTest | Drug)[] = [...this.cartProductsSubject.getValue() as (MedicalTest | Drug)[]];
    const updatedCart = [
      ...currentCart.filter(item => !products.some(product => product.id === item.id)), 
      ...products
    ];
    this.cartProductsSubject.next(updatedCart);
  }   

  /**
   * Removes the selected cart items
   * @param products selected
   */
  removeFromCart(products: MedicalTest | Drug) {
    const currentCart: (MedicalTest | Drug)[] = [...this.cartProductsSubject.getValue() as (MedicalTest | Drug)[]];
    const updatedCart = currentCart.filter(item => item.id !== products.id);
    this.cartProductsSubject.next(updatedCart);
  }    

  /**
   * Gets the select cart items
   * @return Observable of array of MedicalTest or Drug
   */
  getCartProducts() {
    return this.cartProductsSubject.asObservable();
  }
}
